import { confirmAlert } from "react-confirm-alert";
import { useRef, useState } from "react";
import { Button } from "./Form";
import { HiOutlineCheckCircle, HiOutlineXCircle } from "react-icons/hi";

// Diálogo de confirmación. El botón "Sí" se deshabilita y muestra spinner mientras corre onAccept
// (que suele ser async: crea/edita paciente, cita, visita, pago, etc.). Antes NO se esperaba ni se
// deshabilitaba, así que un doble-click con internet lento disparaba onAccept dos veces → registro
// duplicado. El guard por ref (busy) frena el segundo click de forma síncrona, aunque el re-render
// aún no haya deshabilitado el botón.
function ConfirmDialog({ title, text, html, onAccept, onClose }) {
  const [processing, setProcessing] = useState(false);
  const busy = useRef(false);

  const handleAccept = async () => {
    if (busy.current) return;
    busy.current = true;
    setProcessing(true);
    try {
      await onAccept();
    } finally {
      onClose();
    }
  };

  return (
    <div className="custom-ui flex flex-col text-center gap-5 border border-gray-400 rounded-lg p-5 bg-white">
      <h1 className=" font-bold text-lg">{title}</h1>
      {html ? (
        <div dangerouslySetInnerHTML={{ __html: html }} />
      ) : (
        <p>{text}</p>
      )}
      <div className="flex flex-row gap-5 lg:gap-10">
        <Button
          label={"No"}
          Icon={HiOutlineXCircle}
          onClick={onClose}
          disabled={processing}
        />
        <Button
          label={"Si"}
          Icon={HiOutlineCheckCircle}
          loading={processing}
          onClick={handleAccept}
        />
      </div>
    </div>
  );
}

const ConfirmationAlert = ({ title, text, html, onAccept }) => {
  confirmAlert({
    customUI: ({ onClose }) => (
      <ConfirmDialog
        title={title}
        text={text}
        html={html}
        onAccept={onAccept}
        onClose={onClose}
      />
    ),
  });
};

export default ConfirmationAlert;
